import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { createNewFlexSectionData } from '@/widgets/FlexSection/create';
import { FlexSectionDirection } from '@/widgets/FlexSection/types';
import { createNewTextData } from '@/widgets/Text/create';

export function createNewOpenDiscussionData(content: string): ManifestInitializedProps {
  const id = genRandId();

  const [textData] = createNewTextData(content, 'header', false);

  const [horizontalSectionData] = createNewFlexSectionData(FlexSectionDirection.row, [
    { id: textData.id, width: 800, height: 'auto', isDeletable: false, isDraggable: false }
  ]);
  const { id: horizontalSectionId } = horizontalSectionData;
  const childrenArray = new Y.Array();
  childrenArray.push([horizontalSectionId]);

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.OpenDiscussion],
        ['children', childrenArray],
        ['enabledPictureUpload', false],
        ['enabledMultiplePosts', false]
      ])
    },
    horizontalSectionData,
    textData
  ];
}
